export const OPEN_CF = 'OPEN_CF';
export const EDIT_CLIENT = 'EDIT_CLIENT';
export const ASSIGN_ACCOUNT = 'ASSIGN_ACCOUNT';
export const ASSIGN_ACCOUNTS = 'ASSIGN_ACCOUNTS';
export const UNASSIGN_ACCOUNT = 'UNASSIGN_ACCOUNT';
export const ADD_GROUP = 'ADD_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const MOVE_GROUP = 'MOVE_GROUP';
export const MOVE_GROUP_UP = 'MOVE_GROUP_UP';
export const MOVE_GROUP_DOWN = 'MOVE_GROUP_DOWN';
export const RENAME_GROUP = 'RENAME_GROUP';
export const EDIT_GROUP_CODE = 'EDIT_GROUP_CODE';
export const EDIT_GROUP_NUMBER = 'EDIT_GROUP_NUMBER';
export const SET_GROUPS_EXPANDED = 'SET_GROUPS_EXPANDED';
export const SORT_GROUPS = 'SORT_GROUPS';
export const SORT_ACCOUNTS = 'SORT_ACCOUNTS';
export const SET_SHOULD_SYNC_EXPANDED_STATES =
  'SET_SHOULD_SYNC_EXPANDED_STATES';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const IMPORT_ACCOUNTS = 'IMPORT_ACCOUNTS';
export const IMPORT_ACCOUNTS_WITH_ADDING = 'IMPORT_ACCOUNTS_WITH_ADDING';
export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
export const MAP_ACCOUNTS = 'MAP_ACCOUNTS';
export const ADD_PERIOD = 'ADD_PERIOD';
export const REMOVE_PERIOD = 'REMOVE_PERIOD';
export const EDIT_PERIOD = 'EDIT_PERIOD';
export const MOVE_PERIOD = 'MOVE_PERIOD';
export const PERIOD_REORDER = 'PERIOD_REORDER';
export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const EDIT_ACCOUNT_DESCRIPTION = 'EDIT_ACCOUNT_DESCRIPTION';
export const JOURNAL_ADD_UPDATE = 'JOURNAL_ADD_UPDATE';
export const JOURNAL_REMOVE = 'JOURNAL_REMOVE';
export const JOURNAL_POST = 'JOURNAL_POST';
export const JOURNAL_UNPOST = 'JOURNAL_UNPOST';
export const ADD_SUBSIDIARY = 'ADD_SUBSIDIARY';
export const REMOVE_SUBSIDIARY = 'REMOVE_SUBSIDIARY';
export const UPDATE_SUBSIDIARY = 'UPDATE_SUBSIDIARY';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const HIDE_ERROR = 'HIDE_ERROR';
export const CHECK_IF_LOGGED_IN_BEGIN = 'CHECK_IF_LOGGED_IN_BEGIN';
export const CHECK_IF_LOGGED_IN = 'CHECK_IF_LOGGED_IN';
export const CHECK_IF_LOGGED_IN_FAILURE = 'CHECK_IF_LOGGED_IN_FAILURE';
export const CHECK_IF_HAS_SUBSCRIPTION_BEGIN =
  'CHECK_IF_HAS_SUBSCRIPTION_BEGIN';
export const CHECK_IF_HAS_SUBSCRIPTION = 'CHECK_IF_HAS_SUBSCRIPTION';
export const CHECK_IF_HAS_SUBSCRIPTION_FAILURE =
  'CHECK_IF_HAS_SUBSCRIPTION_FAILURE';
export const ADD_IMPORT_BEGIN = 'ADD_IMPORT_BEGIN';
export const ADD_IMPORT = 'ADD_IMPORT';
export const ADD_IMPORT_FAILURE = 'ADD_IMPORT_FAILURE';
export const SET_COLUMN_STATE = 'SET_COLUMN_STATE';
export const SET_GROUP_STATE = 'SET_GROUP_STATE';
export const IMPORT_GROUPS = 'IMPORT_GROUPS';
export const MAP_ACCOUNTS_TO_GROUPS = 'MAP_ACCOUNTS_TO_GROUPS';
export const KPI_ADD_UPDATE = 'KPI_ADD_UPDATE';
export const KPI_REMOVE = 'KPI_REMOVE';
export const ADD_KPI_GROUP = 'ADD_KPI_GROUP';
export const REMOVE_KPI_GROUP = 'REMOVE_KPI_GROUP';
export const EDIT_KPI_GROUP = 'EDIT_KPI_GROUP';
export const MOVE_KPI_GROUP_UP = 'MOVE_KPI_GROUP_UP';
export const MOVE_KPI_GROUP_DOWN = 'MOVE_KPI_GROUP_DOWN';
export const MOVE_KPI_UP = 'MOVE_KPI_UP';
export const MOVE_KPI_DOWN = 'MOVE_KPI_DOWN';
export const SET_ACCOUNTS_FILTER = 'SET_ACCOUNTS_FILTER';
export const LEAD_SCHEDULE_REPORT_SAVE_SELECTED_GROUPS =
  'LEAD_SCHEDULE_REPORT_SAVE_SELECTED_GROUPS';
export const RESTORE_PREVIOUS_STATE = 'RESTORE_PREVIOUS_STATE';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const ADD_EXCHANGE_RATE = 'ADD_EXCHANGE_RATE';
export const EDIT_EXCHANGE_RATE = 'EDIT_EXCHANGE_RATE';
export const REMOVE_EXCHANGE_RATE = 'REMOVE_EXCHANGE_RATE';
export const SAVE_EXCHANGE_RATE = 'SAVE_EXCHANGE_RATE';
